import React from "react";
import "./SelectUserComponent.css";
import Select from 'react-select';

export function SelectUserComponent({ usersArray, selectedUser, onChange, isDisabled = false }) {
  return (
    <div className="select-user-container">
      <Select
        className='toolbar-person-selector'
        maxMenuHeight={'200px'}
        value={selectedUser}
        getOptionLabel={option => option.displayName}
        getOptionValue={option => option.cogId}
        options={usersArray}
        isDisabled={isDisabled}
        styles={{
          control: (provided) => ({
            ...provided,
            boxShadow: "none",
            border: "none",
            backgroundColor: isDisabled ? "#e0e0e0" : "#ffffff",
            color: "#000000",
            width: "100%",
            cursor: isDisabled ? "not-allowed" : "pointer",
          })
        }}
        placeholder={"Select Person"}
        noOptionsMessage={() => 'Unable to find available IT staff'}
        onChange={onChange}
      />
    </div>
  );
}
